import { get } from 'underscore';
import { generateNameSuggestionSuffix as generateNameSuggestionSuffixBase } from '@bingads-webui-campaign/audience-campaign-shared';
import { getDefaultLocationTargetsViewModel, getDefaultLanguagesViewModel } from '@bingads-webui-campaign-react/wizard-shared-components';

export const generateNameSuggestionSuffix = (prefix) => {
  const addz = function (n) {
    if (n < 10) {
      return `0${n}`;
    }
    return `${n}`;
  };

  const baseName = generateNameSuggestionSuffixBase(prefix);
  const today = new Date();

  return `${baseName}${addz(today.getSeconds())}`;
};

const isCnMarket = serverContext => get(serverContext, ['Permissions', 'IsDomesticSimplifiedChineseEnabled'], false);
const isLocationTargetingEnabled = serverContext => get(serverContext, ['DynamicPermissions', 'WindowsStoreLocationTargeting']);

export const getDefaultCampaign = (i18n, serverContext) => ({
  data: {
    Status: 'Paused',
    Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Windows Store Campaign'))),
    Budget: {
      Amount: 100,
      Type: 'DailyStandard',
    },
    Languages: getDefaultLanguagesViewModel(isCnMarket(serverContext)),
    locationTargets: isLocationTargetingEnabled(serverContext) && getDefaultLocationTargetsViewModel(isCnMarket(serverContext)),
    BiddingScheme: {
      Type: 'ManualCpa',
      ManualCPI: undefined,
    },
    CampaignType: 'App',
  },
  isValid: true,
  isDirty: false,
  messages: [],
});

export const getDefaultAssetGroup = i18n => ({
  data: {
    Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Windows Store Asset Group'))),
    Status: 'Active',
  },
  isValid: true,
  isDirty: false,
  messages: [],
});
